import { Constants } from '../constants';
import { AssignmentPriorities } from '../enums/assignment-priorities.enum';
import { AssignmentStatuses } from '../enums/assignment-statuses.enum';
import { ResourceTypes } from '../enums/resource-types.enum';

export class ReorderedEnums {
  public static readonly enumMap = new Map<
    string,
    { key: string; value: unknown }[]
  >([
    [
      Constants.AssignmentStatuses,
      [
        { key: 'ASSIGNMENT_STATUSES.NEW', value: AssignmentStatuses.New },
        { key: 'ASSIGNMENT_STATUSES.ACTIVE', value: AssignmentStatuses.Active },
        { key: 'ASSIGNMENT_STATUSES.COMPLETED', value: AssignmentStatuses.Completed },
        { key: 'ASSIGNMENT_STATUSES.POSTPONED', value: AssignmentStatuses.Postponed },
      ],
    ],
    [
      Constants.AssignmentPriorities,
      [
        { key: 'ASSIGNMENT_PRIORITIES.MIDDLE', value: AssignmentPriorities.Middle },
        { key: 'ASSIGNMENT_PRIORITIES.HIGH', value: AssignmentPriorities.High },
        { key: 'ASSIGNMENT_PRIORITIES.CRITICAL', value: AssignmentPriorities.Critical },
        { key: 'ASSIGNMENT_PRIORITIES.LOW', value: AssignmentPriorities.Low },
      ],
    ],
    [
      Constants.ResourceTypes,
      [
        { key: 'RESOURCE_TYPES.ASSIGNMENT', value: ResourceTypes.Assignment },
        { key: 'RESOURCE_TYPES.PROJECT', value: ResourceTypes.Project },
        { key: 'RESOURCE_TYPES.COMPANY', value: ResourceTypes.Company },
        { key: 'RESOURCE_TYPES.EMPLOYEE', value: ResourceTypes.Employee },
        { key: 'RESOURCE_TYPES.CONTACT', value: ResourceTypes.Contact },
        { key: 'RESOURCE_TYPES.ORGANIZATION', value: ResourceTypes.Organization },
      ],
    ],
  ]);
}
